export default {
      id: "star--filled-usage",
      viewBox: "0 0 15 15",
      url: "../../assets/" + "sprite.svg#star--filled-usage",
      toString: function () {
        return this.url;
      }
    }